import React from 'react';
import {
  DeleteOutlineRounded as DeleteOutlineRoundedIcon,
  DownloadRounded as DownloadRoundedIcon,
} from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import {
  GUARANTEES_APPLICATION_FILES_DELETE_LABEL,
  GUARANTEES_APPLICATION_FILES_DOWNLOAD_LABEL,
} from './constants.ts';
import type { IApplicationFileRowProps } from './types.ts';
import {
  canShowApplicationFileAction,
  getApplicationFileCapabilityDisplayName,
  getApplicationFileDisplayName,
  getApplicationFileId,
} from './utils.ts';

const ApplicationFileRow: React.FC<IApplicationFileRowProps> = ({
  activeAction = null,
  capability,
  file,
  fileIndex,
  onDelete,
  onDownload,
}) => {
  const fileId = getApplicationFileId(file);
  const fileTypeDisplayName = getApplicationFileCapabilityDisplayName(capability);
  const isDownloadActive =
    activeAction?.action === 'download' &&
    activeAction.fileType === capability.fileType &&
    activeAction.fileId === fileId;
  const isDeleteActive =
    activeAction?.action === 'delete' &&
    activeAction.fileType === capability.fileType &&
    activeAction.fileId === fileId;

  return (
    <Box sx={guaranteesClientPageStyles.applicationFilesRow}>
      <Typography sx={guaranteesClientPageStyles.applicationFilesName}>
        {getApplicationFileDisplayName(file, fileIndex, fileTypeDisplayName)}
      </Typography>
      <Box sx={guaranteesClientPageStyles.applicationFilesRowActions}>
        {canShowApplicationFileAction(capability, 'download') && onDownload && (
          <Button
            size="small"
            variant="text"
            startIcon={<DownloadRoundedIcon />}
            disabled={!fileId || isDownloadActive}
            sx={guaranteesClientPageStyles.applicationFilesActionButton}
            onClick={() => {
              void onDownload(capability.fileType, file);
            }}
          >
            {GUARANTEES_APPLICATION_FILES_DOWNLOAD_LABEL}
          </Button>
        )}
        {canShowApplicationFileAction(capability, 'delete') && onDelete && (
          <Button
            size="small"
            color="error"
            variant="text"
            startIcon={<DeleteOutlineRoundedIcon />}
            disabled={!fileId || isDeleteActive}
            sx={guaranteesClientPageStyles.applicationFilesActionButton}
            onClick={() => {
              void onDelete(capability.fileType, file);
            }}
          >
            {GUARANTEES_APPLICATION_FILES_DELETE_LABEL}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ApplicationFileRow;
